import { AddEdit } from '../../../../../interfaces/product.interface';
import { Validation } from '../../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import translate from '../../../../../i18n/config';

export const validateAddEditForm = (formData: AddEdit, fieldName?: string): Validation => {
  let validation: Validation = { validate: true, fields: [] };

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.product_division_id) {
    if (!formData.product_division_id || !String(formData.product_division_id).trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.product_division_id,
        message: translate.t('products.addEdit.pageTexts.form.division.errors.required'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: translate.t('products.addEdit.pageTexts.form.name.errors.required'),
      });
    } else if (formData.name.trim().length > 100) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: translate.t('products.addEdit.pageTexts.form.name.errors.maxLength'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.description) {
    if (!formData.description?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.description,
        message: translate.t('products.addEdit.pageTexts.form.description.errors.required'),
      });
    } else if (formData.description.trim().length > 500) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.description,
        message: translate.t('products.addEdit.pageTexts.form.description.errors.maxLength'),
      });
    }
  }

  return validation;
};
